<ng-container *ngIf="fieldFormGroup">
    <div
        tabindex="0"
        class="job-article-field"
        [formGroup]="fieldFormGroup"
        [ngClass]="{
            'field-group': fieldFormGroup.get('type').value == possibleFieldTypes.Group,
            'checkbox-item-field': fieldFormGroup.get('type').value == possibleFieldTypes.Checkbox,
            'date-item-field': fieldFormGroup.get('type').value == possibleFieldTypes.Date,
            'signature-field': fieldFormGroup.get('type').value == possibleFieldTypes.Signature,
            'text-editor-field': fieldFormGroup.get('type').value == possibleFieldTypes.TextEditor,
            'field-required':
                (fieldFormGroup.get('type').value !== possibleFieldTypes.Product &&
                    fieldFormGroup.get('required').value === true &&
                    (fieldFormGroup.get('value').value === '' ||
                        fieldFormGroup.get('value').value == null ||
                        this.utils.isEmptyArray(fieldFormGroup.get('value').value))) ||
                (fieldFormGroup.get('type').value == possibleFieldTypes.Product &&
                    fieldFormGroup.get('required').value === true &&
                    getSelectedProductsAsFormarray().length == 0),
            'heading-field': fieldFormGroup.get('type').value == possibleFieldTypes.Heading,
        }"
    >
        <!-- Handling for all fields except products / groups / headings -->
        <ion-item
            lines="none"
            color="none"
            (click)="maybeToggleUiControl()"
            *ngIf="
                fieldFormGroup.get('type').value !== possibleFieldTypes.Product &&
                fieldFormGroup.get('type').value !== possibleFieldTypes.Group &&
                fieldFormGroup.get('type').value !== possibleFieldTypes.Heading
            "
        >
            <ion-label class="ion-text-wrap job-article-field-label" id="article-field-label" [position]="'stacked'"
                >{{ fieldFormGroup.get('name').value }}
                <ion-button
                    *ngIf="fieldFormGroup.get('description').value"
                    class="dp-p-0 dp-m-0 article-field-description"
                    size="small"
                    fill="clear"
                    color="dark"
                    dpTooltip
                    tooltipPosition="top"
                    tooltipTrigger="click mouseenter focus"
                    tooltipTheme="light"
                    [tooltipContent]="fieldFormGroup.get('description').value"
                >
                    <fa-icon icon="info-circle" slot="start"></fa-icon>
                    <span *ngIf="fieldFormGroup.get('description').value"
                        >{{ fieldFormGroup.get('description').value | slice: 0 : 40
                        }}{{ fieldFormGroup.get('description').value.length > 40 ? '...' : '' }}</span
                    >
                </ion-button>
            </ion-label>

            <!-- Text field -->
            <ng-container *ngIf="fieldFormGroup.get('type').value == possibleFieldTypes.Text">
                <ion-textarea
                    autocapitalize="true"
                    aria-labelledby="article-field-label"
                    autosize
                    formControlName="value"
                    inputmode="text"
                    rows="1"
                    [placeholder]="'projects.jobs.details.article.fill-value-placeholder' | translate"
                    [readonly]="!changesAllowed"
                >
                </ion-textarea>
            </ng-container>

            <!-- Text Editor field -->
            <ng-container *ngIf="fieldFormGroup.get('type').value == possibleFieldTypes.TextEditor && textEditorInitialized">
                <editor
                    #tinyMceEditor
                    class="dp-text-editor"
                    [init]="editorInit"
                    [outputFormat]="'html'"
                    [formControl]="fieldValueFormControl"
                    [disabled]="!changesAllowed"
                ></editor>

                <!-- Template Selection Modal -->
                <ion-modal #templateModal class="modal-m stack-modal">
                    <ng-template>
                        <ion-header>
                            <ion-toolbar color="none">
                                <ion-title>{{ 'shared.select' | translate }}</ion-title>
                                <ion-buttons slot="end">
                                    <ion-button fill="clear" shape="round" color="primary" (click)="templateModal.dismiss()">
                                        <fa-icon slot="icon-only" icon="times"></fa-icon>
                                    </ion-button>
                                </ion-buttons>
                            </ion-toolbar>
                        </ion-header>
                        <ion-content>
                            <app-text-templates
                                [mode]="fieldFormGroup.get('multiSelect').value === true ? 'select-multiple-templates' : 'select-template'"
                                (templateSelectionChanged)="onTextTemplateChosen($event)"
                                [limitTemplateFolders]="fieldFormGroup.get('allowedFolders')?.value"
                            >
                            </app-text-templates>
                        </ion-content>
                        <ion-footer *ngIf="fieldFormGroup.get('multiSelect').value === true">
                            <ion-toolbar color="none">
                                <ion-buttons slot="end">
                                    <ion-button color="primary" fill="solid" (click)="onMultipleTextTemplatesConfirmed()">
                                        <fa-icon icon="check" slot="start"></fa-icon>
                                        {{ 'projects.jobs.details.article.confirm-text-templates-btn' | translate }}
                                    </ion-button>
                                </ion-buttons>
                            </ion-toolbar>
                        </ion-footer>
                    </ng-template>
                </ion-modal>
            </ng-container>

            <!-- Select field -->
            <ng-container *ngIf="isSelect">
                <ion-text [class.placeholder]="isEmpty" class="dp-select-value">
                    <span *ngIf="isEmpty" class="dp-select-value-mobile-placeholder">
                        {{ 'projects.jobs.details.article.select-placeholder' | translate }}</span
                    >
                    <ng-container *ngFor="let possibleValue of fieldFormGroupPossibleValueControls">
                        <ng-container *ngIf="formFieldIncludesValue(possibleValue.value?.value)">
                            <ion-chip
                                color="dark"
                                outline="true"
                                class="dp-select-option"
                                [style.color]="
                                    possibleValue.value?.icon?.iconName == null &&
                                    ![null, 'transparent'].includes(possibleValue.value?.color)
                                        ? possibleValue.value?.color
                                        : 'inherit'
                                "
                            >
                                <app-field-icon-view
                                    [icon]="possibleValue.value?.icon"
                                    [color]="
                                        ![null, 'transparent'].includes(possibleValue.value?.color) ? possibleValue.value?.color : 'inherit'
                                    "
                                    [lazyLoad]="false"
                                ></app-field-icon-view>
                                {{ possibleValue.value.value }}
                            </ion-chip>
                            <fa-icon
                                icon="link"
                                class="select-value-link"
                                *ngIf="
                                    possibleValue.value?.link != null && possibleValue.value?.link != '' && possibleValue.value?.link != '#'
                                "
                                (click)="openSelectFieldLink(possibleValue.value.link, $event)"
                            ></fa-icon>
                        </ng-container>
                    </ng-container>
                </ion-text>
                <ng-container *ngIf="changesAllowed && renderDrawerComponent">
                    <app-select-drawer
                        [multiple]="fieldFormGroup.get('multiSelect').value"
                        allowEmpty="true"
                        [canAddItems]="isExtendable"
                        appendTo="ion-app"
                        [value]="mobileDrawerValue"
                        [items]="mobileDrawerItems"
                        [stackModal]="asDialog"
                        (onChange)="onMobileSelectItemChanged($event)"
                        (openStateChanged)="drawerOpenStateChanged($event)"
                        #selectDrawer
                    ></app-select-drawer>
                </ng-container>
            </ng-container>

            <!-- Number field -->
            <ng-container *ngIf="fieldFormGroup.get('type').value == possibleFieldTypes.Number">
                <ion-input
                    aria-labelledby="article-field-label"
                    [type]="platformIOS ? 'text' : 'number'"
                    inputmode="decimal"
                    [max]="maxAllowedNumber"
                    formControlName="value"
                    [placeholder]="'projects.jobs.details.article.fill-value-placeholder' | translate"
                    [readonly]="!changesAllowed"
                    (keydown)="validateNumberInputs($event, numInput)"
                    (ionInput)="validateNumberInputChanges($event, numInput)"
                    class="dp-pr-s"
                    #numInput
                ></ion-input>
            </ng-container>

            <!-- Date field -->
            <ng-container *ngIf="fieldFormGroup.get('type').value == possibleFieldTypes.Date">
                <div class="dp-ion-item-content-wrap" (click)="onDateItemClicked()">
                    <input
                        matInput
                        class="dp-ion-input dp-fake-active-input"
                        [placeholder]="'projects.jobs.details.article.date-placeholder' | translate"
                        [value]="datePickerInputData | date: dateFormatForField"
                        [readonly]="true"
                    />

                    <input
                        class="hidden-dateinput"
                        [matDatepicker]="datePicker"
                        (dateChange)="onDateChanged($event)"
                        [readonly]="true"
                        disabled
                    />
                </div>

                <div class="icon-center-button" slot="end">
                    <ion-button
                        *ngIf="datePickerInputData"
                        [disabled]="!changesAllowed"
                        slot="end"
                        fill="clear"
                        class="color-danger round"
                        dpTooltip
                        [tooltipContent]="'projects.jobs.details.article.delete-value-btn' | translate"
                        (click)="resetDatePickerVal($event)"
                    >
                        <fa-icon icon="trash-alt"></fa-icon>
                    </ion-button>
                    <ion-button
                        [disabled]="!changesAllowed"
                        slot="end"
                        fill="clear"
                        class="round"
                        dpTooltip
                        [tooltipContent]="'projects.jobs.details.article.open-calendar-btn' | translate"
                        (click)="datePicker.open()"
                        style="margin-right: 15px"
                    >
                        <fa-icon icon="calendar-alt"></fa-icon>
                    </ion-button>
                </div>
                <mat-datepicker
                    [touchUi]="utils.isPhone || utils.isTablet"
                    disabled="false"
                    [startView]="startViewForDateField"
                    (yearSelected)="onDatePickerYearSelected($event, datePicker)"
                    (monthSelected)="onDatePickerMonthSelected($event, datePicker)"
                    #datePicker
                ></mat-datepicker>
            </ng-container>

            <!-- USER FIELD -->
            <ng-container *ngIf="isUser && userFieldPossibleUsers.length > 0">
                <ion-text [class.placeholder]="isEmpty" class="dp-select-value">
                    <span *ngIf="isEmpty" class="dp-select-value-mobile-placeholder">{{
                        'projects.jobs.details.article.select-placeholder' | translate
                    }}</span>
                    <ng-container *ngIf="fieldValue?.length != null; else singleUserSelected">
                        <!-- multiple users selected -->
                        <ng-container *ngFor="let selectedUser of fieldValue">
                            <ion-chip color="dark" outline="true" class="dp-select-option"
                                >{{ selectedUser.firstName }} {{ selectedUser.lastName }}
                            </ion-chip>
                        </ng-container>
                    </ng-container>
                    <ng-template #singleUserSelected>
                        <ion-chip color="dark" outline="true" class="dp-select-option" *ngIf="fieldValue != null"
                            >{{ fieldValue?.firstName }} {{ fieldValue?.lastName }}
                        </ion-chip>
                    </ng-template>
                </ion-text>
                <ng-container *ngIf="changesAllowed && renderDrawerComponent">
                    <app-select-drawer
                        [multiple]="fieldFormGroup.get('multiSelect').value"
                        allowEmpty="true"
                        appendTo="ion-app"
                        [value]="mobileDrawerValue"
                        [items]="mobileDrawerItems"
                        [stackModal]="asDialog"
                        (onChange)="onMobileSelectItemChanged($event)"
                        (openStateChanged)="drawerOpenStateChanged($event)"
                        #userSelectDrawer
                    ></app-select-drawer>
                </ng-container>
            </ng-container>

            <!--    SIGNATURE FIELD      -->
            <ng-container *ngIf="fieldFormGroup.get('type').value == possibleFieldTypes.Signature">
                <div class="job-signature-display-wrap" *ngIf="getSignatures().length > 0">
                    <ion-row>
                        <ion-col size="12" size-md="6" *ngFor="let signature of getSignatures(); let signatureIndex = index">
                            <div class="job-signature dp-mb-s">
                                <app-attachment-view
                                    [attachment]="signature"
                                    [canDelete]="changesAllowed"
                                    (attachmentDeleted)="onSignatureDeleted(signatureIndex)"
                                    [showAdditionalText]="signature.displayName != null && signature.displayName.trim() !== ''"
                                    [additionalText]="signature.displayName"
                                    [limitedHeight]="'small'"
                                ></app-attachment-view>
                            </div>
                        </ion-col>
                    </ion-row>
                </div>
                <app-signature
                    *ngIf="changesAllowed"
                    [folderPath]="jobId == null ? projectId : projectId + '/jobs/' + jobId"
                    (signatureConfirmed)="onSignatureAdded($event)"
                ></app-signature>
            </ng-container>

            <!-- Time field -->
            <ng-container *ngIf="fieldFormGroup.get('type').value == possibleFieldTypes.Time">
                <div class="dp-ion-item-content-wrap dp-time-picker-wrap">
                    <ngx-mat-timepicker-field
                        class="dp-time-picker-field"
                        [defaultTime]="fieldFormGroup.get('value')?.value"
                        [format]="24"
                        [disabled]="!changesAllowed"
                        [cancelBtnTmpl]="timePickerCloseBtn"
                        [confirmBtnTmpl]="timePickerConfirmBtn"
                        [toggleIcon]="timePickerToggleIcon"
                        (timeChanged)="onTimePickerFieldChanged($event)"
                        #timePickerField
                    ></ngx-mat-timepicker-field>
                </div>

                <ng-template #timePickerToggleIcon>
                    <div class="icon-center-button ion-hide" slot="end">
                        <ion-button #timepickertogglebtn><!-- real trigger is further down below --></ion-button>
                    </div>
                </ng-template>

                <ng-template #timePickerCloseBtn>
                    <ion-button fill="clear" class="ion-text-uppercase">{{ 'core.time-picker.cancel-btn' | translate }} </ion-button>
                </ng-template>
                <ng-template #timePickerConfirmBtn>
                    <ion-button fill="clear" class="ion-text-uppercase">{{ 'core.time-picker.accept-btn' | translate }} </ion-button>
                </ng-template>

                <div class="icon-center-button" slot="end">
                    <ion-button
                        *ngIf="fieldFormGroup.get('value')?.value"
                        [disabled]="!changesAllowed"
                        slot="end"
                        fill="clear"
                        class="color-danger round"
                        dpTooltip
                        [tooltipContent]="'projects.jobs.details.article.delete-value-btn' | translate"
                        (click)="resetTimePickerVal($event)"
                    >
                        <fa-icon icon="trash-alt"></fa-icon>
                    </ion-button>
                    <ion-button
                        [disabled]="!changesAllowed"
                        slot="end"
                        fill="clear"
                        class="round"
                        (click)="openTimepicker()"
                        style="margin-right: 15px"
                    >
                        <fa-icon [icon]="['far', 'clock']"></fa-icon>
                    </ion-button>
                </div>
            </ng-container>

            <!-- Code field -->
            <ng-container *ngIf="fieldFormGroup.get('type').value == possibleFieldTypes.Code">
                <ion-input
                    aria-labelledby="article-field-label"
                    type="text"
                    formControlName="value"
                    [placeholder]="'projects.jobs.details.article.fill-code-placeholder' | translate"
                    [readonly]="!changesAllowed"
                    tabindex="2"
                    class="dp-pr-0"
                ></ion-input>
                <ion-button
                    [disabled]="!changesAllowed"
                    slot="end"
                    fill="clear"
                    class="round"
                    dpTooltip
                    [tooltipContent]="'projects.jobs.details.article.scan-code-placeholder' | translate"
                    tabindex="1"
                    (click)="toggleScan($event)"
                    style="margin-right: 15px"
                >
                    <fa-icon icon="qrcode"></fa-icon>
                </ion-button>
            </ng-container>

            <!-- Calculator field -->
            <ng-container *ngIf="fieldFormGroup.get('type').value == possibleFieldTypes.Calculator">
                <div class="calculator-wrap" (touchstart)="handleCalculatorTouchStart($event)" (click)="onCalculatorFieldClickedOnMobile()">
                    <div class="calculator-input">
                        <ng-container *ngIf="utils.isPhone || utils.isTablet; else calculatorDesktop">
                            <ion-textarea
                                aria-labelledby="article-field-label"
                                autosize
                                formControlName="value"
                                rows="1"
                                [placeholder]="'projects.jobs.details.article.fill-calc-placeholder' | translate"
                                inputmode="none"
                                #calculatorPreviewInput
                            >
                            </ion-textarea>
                            <app-calculator-keyboard
                                [fieldName]="fieldFormGroup.get('name').value"
                                (calculationChanged)="onCalculatorFieldChanged($event)"
                                #calculatorMobileKeyboard
                            ></app-calculator-keyboard>
                        </ng-container>
                        <ng-template #calculatorDesktop>
                            <ion-textarea
                                aria-labelledby="article-field-label"
                                autosize
                                formControlName="value"
                                rows="1"
                                [placeholder]="'projects.jobs.details.article.fill-calc-placeholder' | translate"
                                (ionChange)="onCalculatorFieldChanged($event.detail.value)"
                                (ionInput)="onCalculatorFieldChanged($event.detail.value, false)"
                                [debounce]="500"
                                [readonly]="!changesAllowed"
                            ></ion-textarea>
                        </ng-template>
                    </div>
                    <div class="calculator-result ion-text-right" *ngIf="calculatorCurrentResult != null">
                        <span *ngIf="calculatorCurrentResult === false; else calculatorShowResult" class="color-danger">
                            <fa-icon icon="exclamation-circle"></fa-icon>
                        </span>
                        <ng-template #calculatorShowResult>
                            <strong> = {{ calculatorCurrentResult }} </strong>
                        </ng-template>
                    </div>
                </div>
            </ng-container>

            <!-- Linking field -->
            <ng-container *ngIf="fieldFormGroup.get('type').value == possibleFieldTypes.Linking">
                <div class="job-field-linking-wrap" style="width: 100%">
                    <app-job-linkings
                        #jobLinkingsComp
                        [linkedJobIds]="fieldValue"
                        (removeJobLinkRequested)="onRemoveJobLink($event.removedJobLinkIndex, $event.removedJobLinkId)"
                    ></app-job-linkings>
                </div>
                <div class="job-linking-action ion-text-end" style="width: 100%" *ngIf="changesAllowed">
                    <app-new-job-linking
                        [currentJobId]="jobId"
                        [linkFieldName]="fieldFormGroup.get('name').value"
                        [allowedRelations]="fieldFormGroup.get('allowedRelations')?.value"
                        (jobLinkConfirmed)="onAddJobLink($event)"
                        autoLinkNewCreatedJobs="false"
                    ></app-new-job-linking>
                </div>
            </ng-container>

            <div class="warning-icon">
                <ng-container
                    *ngIf="
                        fieldFormGroup.get('required').value === true &&
                        (fieldFormGroup.get('value').value === '' ||
                            fieldFormGroup.get('value').value == null ||
                            this.utils.isEmptyArray(fieldFormGroup.get('value').value))
                    "
                >
                    <fa-icon icon="keyboard" class="color-warning"></fa-icon>
                </ng-container>
            </div>

            <!-- Action Buttons +/- for number field -->
            <ng-container *ngIf="changesAllowed && fieldFormGroup.get('type').value == possibleFieldTypes.Number">
                <ion-button slot="end" fill="solid" class="round number-field-step-btn" tabindex="1" (click)="stepNumberField('down')">
                    <fa-icon icon="minus"></fa-icon>
                </ion-button>
                <ion-button
                    slot="end"
                    fill="solid"
                    class="round number-field-step-btn"
                    tabindex="1"
                    (click)="stepNumberField('up')"
                    style="margin-right: 15px"
                >
                    <fa-icon icon="plus"></fa-icon>
                </ion-button>
            </ng-container>

            <!-- Checkbox field -->
            <ng-container *ngIf="isCheckbox">
                <ion-item class="checkbox-item ion-justify-content-end" lines="none" class="bg-transparent">
                    <ion-grid>
                        <ion-row class="checkbox-row">
                            <ion-col
                                class="checkbox-field no-padding"
                                *ngFor="let possibleCheckboxValue of fieldFormGroupPossibleValueControls"
                            >
                                <ion-label [ngStyle]="{ color: possibleCheckboxValue.get('color').value }">
                                    <app-field-icon-view
                                        [icon]="possibleCheckboxValue.get('icon').value"
                                        [color]="
                                            possibleCheckboxValue.get('color').value != null
                                                ? possibleCheckboxValue.get('color').value
                                                : '#000000'
                                        "
                                        [limitSize]="'22px'"
                                        [lazyLoad]="false"
                                        class="dp-mr-s"
                                    ></app-field-icon-view>
                                    {{ possibleCheckboxValue.get('value').value }}
                                </ion-label>

                                <ng-container *ngIf="fieldFormGroup.get('multiSelect').value === true">
                                    <ion-checkbox
                                        (ionChange)="onCheckboxClicked($event.target.checked, possibleCheckboxValue.value)"
                                        [checked]="isCheckBoxChecked(possibleCheckboxValue.value)"
                                        [disabled]="!changesAllowed"
                                    ></ion-checkbox>
                                </ng-container>
                                <ng-container *ngIf="fieldFormGroup.get('multiSelect').value === false">
                                    <!-- we have to invert the checked property in click event because the property is not set at the time the user clicks -->
                                    <ion-checkbox
                                        (click)="onCheckboxClicked(!$event.target.checked, possibleCheckboxValue.value)"
                                        [checked]="isCheckBoxChecked(possibleCheckboxValue.value)"
                                        [disabled]="!changesAllowed"
                                    ></ion-checkbox>
                                </ng-container>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </ion-item>
            </ng-container>
        </ion-item>

        <!-- Product field -->
        <ng-container *ngIf="fieldFormGroup.get('type').value === possibleFieldTypes.Product">
            <ion-label class="ion-text-wrap job-product-field-label" [position]="'stacked'"
                >{{ fieldFormGroup.get('name').value }}
                <ion-button
                    *ngIf="fieldFormGroup.get('description').value"
                    class="dp-p-0 dp-m-0 article-field-description"
                    size="small"
                    fill="clear"
                    color="dark"
                    dpTooltip
                    tooltipPosition="top"
                    tooltipTrigger="click mouseenter focus"
                    tooltipTheme="light"
                    [tooltipContent]="fieldFormGroup.get('description').value"
                >
                    <fa-icon icon="info-circle" slot="start"></fa-icon>
                    <span *ngIf="fieldFormGroup.get('description').value"
                        >{{ fieldFormGroup.get('description').value | slice: 0 : 40
                        }}{{ fieldFormGroup.get('description').value.length > 40 ? '...' : '' }}</span
                    >
                </ion-button>
            </ion-label>
            <div class="field-products-wrap" formArrayName="selectedProducts">
                <ng-container *ngFor="let productEntry of getSelectedProductsAsFormarray().controls; let productIndex = index">
                    <ion-item class="field-product-entry bg-transparent" [formGroup]="productEntry">
                        <div class="field-product-name">
                            <ng-container *ngIf="hasVisibleMetaInfo(productEntry.get('metaInfo')?.value)">
                                <fa-icon
                                    class="meta-info"
                                    icon="info-circle"
                                    dpTooltip
                                    [tooltipContent]="tooltipContentForProduct(productEntry.get('metaInfo')?.value)"
                                    tooltipTrigger="click mouseenter focus"
                                ></fa-icon>
                            </ng-container>

                            {{ productEntry.get('name').value }}
                        </div>
                        <div class="field-product-amount" *ngIf="productEntry.get('enableAmount').value === true">
                            <ion-input
                                [label]="productEntry.get('unit').value || ('projects.jobs.details.article.amount-placeholder' | translate)"
                                [type]="platformIOS ? 'text' : 'number'"
                                inputmode="decimal"
                                formControlName="amount"
                                [placeholder]="
                                    'projects.jobs.details.article.fill-field-placeholder'
                                        | translate
                                            : {
                                                  name:
                                                      productEntry.get('unit').value ||
                                                      ('projects.jobs.details.article.amount' | translate),
                                              }
                                "
                                [readonly]="!changesAllowed"
                                class="dp-pr-s"
                            ></ion-input>
                        </div>
                        <div class="field-product-action">
                            <ion-buttons slot="end" *ngIf="changesAllowed">
                                <ion-button
                                    fill="clear"
                                    size="small"
                                    color="danger"
                                    class="product-remove-action"
                                    (click)="onProductRemoved(productIndex)"
                                >
                                    <fa-icon icon="trash" slot="icon-only"></fa-icon>
                                </ion-button>
                            </ion-buttons>
                        </div>
                    </ion-item>
                </ng-container>
            </div>
            <div
                class="field-product-add-action"
                *ngIf="fieldFormGroup.get('multiSelect').value === true || getSelectedProductsAsFormarray().length === 0"
            >
                <ion-item class="bg-transparent">
                    <div class="field-product-wrap" (click)="onAddProductClicked()">
                        <ion-input
                            class="field-product-add-action-fake-input"
                            [readonly]="true"
                            [placeholder]="
                                fieldFormGroup.get('multiSelect').value === true
                                    ? ('shared.add' | translate)
                                    : ('shared.select' | translate)
                            "
                        ></ion-input>
                    </div>
                    <div class="warning-icon" slot="end">
                        <ng-container
                            *ngIf="
                                fieldFormGroup.get('multiSelect').value === true &&
                                fieldFormGroup.get('required').value === true &&
                                getSelectedProductsAsFormarray().length == 0
                            "
                        >
                            <fa-icon icon="keyboard" class="color-warning"></fa-icon>
                        </ng-container>
                        <ng-container
                            *ngIf="
                                fieldFormGroup.get('multiSelect').value === false &&
                                fieldFormGroup.get('required').value === true &&
                                (fieldFormGroup.get('value').value === '' || fieldFormGroup.get('value').value == null)
                            "
                        >
                            <fa-icon icon="keyboard" class="color-warning"></fa-icon>
                        </ng-container>
                    </div>
                </ion-item>
            </div>

            <!-- Product Selection Modal -->
            <ion-modal class="modal-m stack-modal" [isOpen]="productModalVisible" (ionModalDidDismiss)="productModalVisible = false">
                <ng-template>
                    <ion-header>
                        <ion-toolbar color="none">
                            <ion-title>{{ 'shared.select' | translate }}</ion-title>
                            <ion-buttons slot="end">
                                <ion-button fill="clear" shape="round" color="primary" (click)="productModalVisible = false">
                                    <fa-icon slot="icon-only" icon="times"></fa-icon>
                                </ion-button>
                            </ion-buttons>
                        </ion-toolbar>
                    </ion-header>
                    <ion-content>
                        <app-products
                            [mode]="fieldFormGroup.get('multiSelect').value === true ? 'select-multiple-products' : 'select-product'"
                            (productSelectionChanged)="onProductChosen($event)"
                            [limitProductFolders]="fieldFormGroup.get('allowedFolders')?.value"
                        ></app-products>
                    </ion-content>
                    <ion-footer *ngIf="fieldFormGroup.get('multiSelect').value === true">
                        <ion-toolbar color="none">
                            <ion-buttons slot="end">
                                <ion-button color="primary" fill="solid" (click)="onMultipleProductsConfirmed()">
                                    <fa-icon icon="check" slot="start"></fa-icon>
                                    {{ 'projects.jobs.details.article.confirm-products-btn' | translate }}
                                </ion-button>
                            </ion-buttons>
                        </ion-toolbar>
                    </ion-footer>
                </ng-template>
            </ion-modal>
        </ng-container>

        <!-- Group field -->
        <ng-container *ngIf="fieldFormGroup.get('type').value === possibleFieldTypes.Group">
            <div class="job-field-group">
                <h4 class="job-field-group-heading">
                    <strong
                        >{{ fieldFormGroup.get('name').value
                        }}{{ getDuplicationNumber(fieldFormGroup.get('duplicationNumber').value) }}</strong
                    >
                    <div
                        class="repetition-actions"
                        *ngIf="fieldFormGroup.get('repetition').value === true || fieldFormGroup.get('duplicationNumber').value !== null"
                    >
                        @if (changesAllowed) {
                            <ion-button
                                class="round"
                                size="small"
                                fill="outline"
                                dpTooltip
                                [tooltipContent]="
                                    'projects.jobs.details.article.field-repeat-placeholder'
                                        | translate: { name: getNameOfRepetitionField() }
                                "
                                (click)="onDuplicateGroupButton(fieldFormGroup.get('_id').value)"
                            >
                                <fa-icon icon="clone"></fa-icon>
                            </ion-button>
                            <ng-container *ngIf="fieldFormGroup.get('repetition').value === false">
                                <ion-button
                                    class="round delete-repetition-button"
                                    size="small"
                                    fill="outline"
                                    color="danger"
                                    (click)="onDeleteDuplicatedGroupButton(fieldFormGroup.get('_id').value)"
                                    dpTooltip
                                    [tooltipContent]="
                                        'projects.jobs.details.article.field-delete-placeholder'
                                            | translate: { name: getNameOfRepetitionField() }
                                    "
                                >
                                    <fa-icon icon="trash"></fa-icon>
                                </ion-button>
                            </ng-container>
                        }
                    </div>
                </h4>
                <div class="job-field-group-sub-fields" formArrayName="subFields">
                    <ng-container *ngFor="let subField of getSubFieldsFormArray().controls">
                        <ng-container *ngIf="publicView; else normalArticleView">
                            <ng-container *ngIf="!utils.notAllowedFileTypesForPublicView.includes(subField.get('type').value)">
                                <ng-container [ngTemplateOutlet]="articleFieldHtml"></ng-container>
                            </ng-container>
                        </ng-container>
                        <ng-template #normalArticleView>
                            <ng-container [ngTemplateOutlet]="articleFieldHtml"></ng-container>
                        </ng-template>

                        <ng-template #articleFieldHtml>
                            <div
                                class="job-article-field-wrap job-sub-field-wrap"
                                *ngIf="subFieldVisibilityMapping[subField.get('_id').value]"
                                [style.flex-basis]="
                                    subField.get('dynamicWidth').value != null ? subField.get('dynamicWidth').value + '%' : 'auto'
                                "
                            >
                                <app-job-article-field
                                    [publicView]="publicView"
                                    [projectId]="projectId"
                                    [jobId]="jobId"
                                    [fieldFormGroup]="subField"
                                    [changesAllowed]="changesAllowed"
                                    [linkFieldRelation]="linkFieldRelation"
                                    [asDialog]="asDialog"
                                    (duplicateGroup)="onDuplicateGroup(subField.get('_id').value)"
                                    (deleteDuplicatedGroup)="onDeleteDuplicatedGroup(subField.get('_id').value)"
                                    (lockRequested)="lockRequested.emit($event)"
                                    (jobSaveRequested)="jobSaveRequested.emit()"
                                ></app-job-article-field>
                            </div>
                        </ng-template>
                    </ng-container>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="fieldFormGroup.get('type').value === possibleFieldTypes.Heading">
            {{ fieldFormGroup.get('name').value }}
        </ng-container>
    </div>

    <!-- Code field Scan Dialog -->
    <ion-modal class="stack-modal" [isOpen]="codeFieldScanModalVisible" (ionModalDidDismiss)="codeFieldScanModalVisible = false">
        <ng-template>
            <ion-header>
                <ion-header>
                    <ion-toolbar color="light">
                        <ion-title>{{ 'projects.jobs.details.article.scan-code-placeholder' | translate }}</ion-title>
                        <ion-buttons slot="end">
                            <ion-button fill="clear" shape="round" color="primary" (click)="codeFieldScanModalVisible = false">
                                <fa-icon slot="icon-only" icon="times"></fa-icon>
                            </ion-button>
                        </ion-buttons>
                    </ion-toolbar>
                </ion-header>
            </ion-header>
            <ion-content class="ion-no-padding">
                <app-code-scanner
                    class="dialog-scanner"
                    [(isEnabled)]="codeFieldScanModalVisible"
                    containerType="modal"
                    [searchIcon]="'search'"
                    [searchTextPlaceholder]="'projects.jobs.details.article.code-scanner-placeholder' | translate"
                    (onScanCancel)="codeFieldScanModalVisible = false"
                    (onScanResult)="onScanFieldCodeResult($event)"
                ></app-code-scanner>
            </ion-content>
        </ng-template>
    </ion-modal>
</ng-container>
